function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.8 3.45c.87-.52 1.82-.92 2.83-1.17a2.5 2.5 0 004.74 0c1.01.25 1.96.65 2.82 1.17a2.5 2.5 0 003.36 3.36c.52.86.92 1.8 1.17 2.82a2.5 2.5 0 000 4.74c-.25 1.01-.65 1.96-1.17 2.82a2.5 2.5 0 00-3.36 3.36c-.86.52-1.8.92-2.82 1.17a2.5 2.5 0 00-4.74 0c-1.01-.25-1.96-.65-2.82-1.17a2.5 2.5 0 00-3.36-3.36 9.939 9.939 0 01-1.17-2.82 2.5 2.5 0 000-4.74c.25-1.01.65-1.96 1.17-2.82a2.5 2.5 0 003.36-3.36H6.8zM12 16a4 4 0 100-8 4 4 0 000 8z",
  fill: "#A5B3BB"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 14a2 2 0 100-4 2 2 0 000 4z",
  fill: "#000"
});

var SvgConfiguration = function SvgConfiguration(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgConfiguration;